var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5c-.275 0-.5.225-.5.5v12c0 .275.225.5.5.5h7c.275 0 .5-.225.5-.5V6c0-.275-.225-.5-.5-.5zm-2 .5c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2h-7c-1.103 0-2-.897-2-2zM11 16.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5"
  })));
};
export default SvgMobile;